module.exports = __webpack_public_path__ + "a22b481afe6a7bdd945746075fc3edd6.jpg";